"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7984],{

/***/ 63603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(17058);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PanIcon.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 256 256"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M166.898 204.279C172.402 190.795 170.197 176.127 166.942 163.633C164.747 155.208 156.522 149.043 143.339 146.339C130.289 143.662 113.23 144.62 95.212 149.658C77.1941 154.696 61.9863 162.761 52.0088 171.877C41.9295 181.085 37.8164 190.7 40.0117 199.126C43.2669 211.619 48.4857 225.444 59.7919 234.228C70.9463 242.894 88.7701 247.193 118.461 238.891C148.152 230.589 161.467 217.582 166.898 204.279ZM119.268 241.986C179.746 225.075 176.514 188.072 169.929 162.798C164.622 142.43 131.106 136.301 94.4056 146.563C57.7053 156.825 31.7183 179.593 37.0251 199.961C43.6102 225.235 58.7891 258.897 119.268 241.986Z",
                fill: "#464649"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M155.801 175.68C158.653 186.628 180.351 181.576 214.977 171.894C249.604 162.212 257.158 150.578 254.305 139.63C251.453 128.682 244.685 121.053 216.678 128.884C182.051 138.566 152.948 164.732 155.801 175.68Z",
                fill: "#606063"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M159.97 178.737L175.437 178.709C178.284 178.704 178.523 174.429 177.474 164.815C176.82 158.816 173.457 154.101 171.27 155.477L159.942 163.875L159.97 178.737Z",
                fill: "#464649"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M162.261 177.996C160.059 177.319 159.158 176.266 158.788 174.845C158.644 174.296 158.636 173.375 159.104 171.965C159.566 170.568 160.432 168.889 161.754 166.98C164.397 163.161 168.612 158.775 174.091 154.332C185.037 145.456 200.6 136.7 217.484 131.979C231.34 128.104 239.201 128.297 243.777 130.191C248.018 131.946 250.005 135.425 251.319 140.465C251.901 142.7 251.928 144.848 251.283 146.962C250.634 149.091 249.235 151.411 246.622 153.858C241.312 158.83 231.342 163.998 214.171 168.799C196.798 173.657 182.967 177.263 173.149 178.336C168.216 178.875 164.644 178.728 162.261 177.996ZM214.977 171.894C180.351 181.576 158.653 186.628 155.801 175.68C152.948 164.732 182.051 138.566 216.678 128.884C244.685 121.053 251.453 128.682 254.305 139.63C257.158 150.578 249.604 162.212 214.977 171.894Z",
                fill: "#464649"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M169.925 161.024C176.511 186.298 179.743 223.301 119.264 240.212C58.7859 257.123 43.607 223.461 37.022 198.187C31.7151 177.819 57.7022 155.052 94.4024 144.789C131.103 134.527 164.619 140.656 169.925 161.024Z",
                fill: "#606063"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M62.2322 217.512C45.5076 212.12 42.4613 203.795 40.3848 196.052L41.9594 211.275L50.2352 225.685L64.4374 238.481L80.947 244.327C82.4065 243.612 89.4986 243.299 83.1029 242.028C76.7073 240.758 72.7474 234.756 69.9914 231.378C68.2638 226.484 67.7365 219.287 62.2322 217.512Z",
                fill: "#464649"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M166.895 202.505C172.399 189.021 170.194 174.353 166.939 161.86C164.744 153.434 156.519 147.269 143.336 144.565C130.286 141.888 113.227 142.846 95.2088 147.884C77.1909 152.922 61.9831 160.987 52.0056 170.103C41.9263 179.311 37.8132 188.926 40.0086 197.352C43.2637 209.845 48.4825 223.67 59.7887 232.454C70.9431 241.12 88.7669 245.419 118.458 237.117C148.149 228.815 161.464 215.809 166.895 202.505ZM119.264 240.212C179.743 223.301 176.511 186.298 169.925 161.024C164.619 140.656 131.103 134.527 94.4024 144.789C57.7022 155.052 31.7151 177.819 37.022 198.187C43.607 223.461 58.7859 257.123 119.264 240.212Z",
                fill: "#464649"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M164.233 181.686C165.018 182.322 165.157 183.497 164.543 184.311C162.98 186.382 161.187 188.422 159.188 190.412C158.469 191.128 157.327 191.104 156.636 190.36C155.945 189.615 155.968 188.431 156.687 187.716C158.576 185.834 160.252 183.925 161.7 182.007C162.314 181.193 163.448 181.05 164.233 181.686ZM57.4215 216.239C57.6566 215.235 58.6323 214.619 59.6008 214.863C73.2899 218.308 91.7045 217.793 111.035 212.388C120.262 209.808 128.779 206.37 136.271 202.374C137.157 201.901 138.245 202.263 138.701 203.181C139.157 204.099 138.809 205.226 137.923 205.699C130.195 209.821 121.438 213.352 111.976 215.998C92.2044 221.527 73.1589 222.124 58.7494 218.497C57.7809 218.253 57.1863 217.242 57.4215 216.239Z",
                fill: "#979797"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M159.836 163.292C164.405 180.829 141.059 195.381 109.857 204.106C78.655 212.831 51.4793 212.682 46.8428 194.887C42.2064 177.092 65.6193 162.798 96.8214 154.074C128.024 145.349 155.266 145.755 159.836 163.292Z",
                fill: "#464649"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M145.831 183.549C154.508 176.998 157.462 170.578 155.854 164.406C154.245 158.233 148.575 154.225 137.894 153.086C127.333 151.96 113.281 153.898 97.8965 158.2C82.4985 162.506 69.3986 168.094 60.8132 174.54C52.1526 181.043 49.1801 187.461 50.825 193.774C52.4698 200.087 58.1557 204.083 68.7987 205.189C79.3491 206.285 93.384 204.285 108.782 199.98C124.166 195.678 137.251 190.028 145.831 183.549ZM110.264 205.113C141.466 196.388 164.405 180.829 159.836 163.292C155.266 145.755 128.024 145.349 96.8214 154.074C65.6193 162.798 42.2064 177.092 46.8428 194.887C51.4793 212.682 79.0614 213.838 110.264 205.113Z",
                fill: "#737373"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M103.877 181.153C89.0555 185.297 76.4977 192.072 68.1169 199.619C67.3647 200.297 66.2249 200.214 65.5711 199.434C64.9173 198.655 64.997 197.474 65.7492 196.796C74.622 188.806 87.7006 181.803 102.936 177.543C106.034 176.676 109.107 175.955 112.134 175.375C113.114 175.187 114.056 175.858 114.237 176.873C114.419 177.889 113.771 178.864 112.792 179.052C109.86 179.614 106.881 180.313 103.877 181.153ZM123.847 175.658C123.792 174.627 124.554 173.745 125.549 173.688C132.378 173.297 138.774 173.682 144.424 174.797C145.403 174.991 146.046 175.97 145.86 176.984C145.673 177.999 144.728 178.664 143.749 178.471C138.431 177.421 132.333 177.045 125.749 177.422C124.753 177.479 123.902 176.69 123.847 175.658Z",
                fill: "#606063"
            })
        ]
    }));
};
/* harmony default export */ var PanIcon = (Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/PancakeIcon.tsx





var PancakeIcon_Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 128 128"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "128",
            height: "128",
            viewBox: "0 0 128 128",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M56.7204 37.5858C56.7204 45.3822 58.0271 54.1169 60.2906 60.8591C61.4246 64.2369 62.7705 67.0285 64.249 68.946C65.742 70.8826 67.1906 71.7103 68.5307 71.7103C71.1919 71.7103 74.4165 70.5307 77.8384 68.3524C81.235 66.1902 84.7001 63.1234 87.8127 59.5481C94.0844 52.3439 98.6784 43.3694 98.6784 35.942C98.6784 28.1653 97.1567 21.2636 93.9931 16.3543C90.8793 11.5222 86.1363 8.54284 79.3564 8.54284C72.6009 8.54284 66.9825 11.9157 63.0072 17.2564C59.0174 22.6164 56.7204 29.9263 56.7204 37.5858Z",
                    fill: "#FEDC90",
                    stroke: "#D1884F",
                    strokeWidth: "2.89134"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M32.7442 66.7859C39.4364 62.9222 47.2575 60.5211 53.8454 59.9252C57.1411 59.6272 60.0564 59.7876 62.336 60.3933C64.6294 61.0028 66.1079 62.0118 66.8368 63.2742C69.6116 68.0804 69.9429 76.4856 67.7501 84.8501C65.5656 93.1829 61.0085 100.957 54.6069 104.653C47.9434 108.5 40.9505 110.185 34.8292 109.454C28.7533 108.729 23.476 105.626 20.0729 99.7316C16.6658 93.8305 16.5364 87.5528 18.8757 81.7754C21.228 75.9659 26.1018 70.6209 32.7442 66.7859Z",
                    fill: "#D1884F",
                    stroke: "#633001",
                    strokeWidth: "2.89134"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M73.6122 7.76013C69.4145 8.86483 64.8207 11.0867 61.24 16.1556C53.2804 27.4231 51.7006 41.9592 58.5495 60.7386C65.3984 79.518 63.3431 89.9236 56.0487 98.3189C48.7543 106.714 29.475 108.685 23.3482 101.929C21.8481 100.274 17.4954 97.4588 20.3675 102.54C23.2397 107.622 30.7527 111.748 39.59 111.748C48.4273 111.748 55.5943 108.146 61.958 101.338C68.3217 94.5306 74.292 78.3883 68.3268 61.7709C60.6331 40.3385 62.8311 27.508 68.2893 19.7815C71.0879 15.8198 75.5453 12.3629 78.6077 10.5868C81.8233 8.72183 84.8797 8.42294 86.8682 8.42294C83.3332 6.65548 77.8099 6.65542 73.6122 7.76013Z",
                    fill: "#633001"
                })
            ]
        })
    }));
};
/* harmony default export */ var PancakeIcon = (PancakeIcon_Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% {\n		transform: translatey(0px);\n	}\n	50% {\n		transform: translatey(10px);\n	}\n	100% {\n		transform: translatey(0px);\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: ",
        " 2s linear infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 6s ease-in-out infinite;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Spinner_float = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-da0aae9d-0"
}).withConfig({
    componentId: "sc-746f83e0-0"
})(_templateObject2());
var RotatingPancakeIcon = (0,styled_components_browser_esm/* default */.ZP)(PancakeIcon).withConfig({
    componentId: "sc-da0aae9d-1"
}).withConfig({
    componentId: "sc-746f83e0-1"
})(_templateObject3(), rotate);
var FloatingPanIcon = (0,styled_components_browser_esm/* default */.ZP)(PanIcon).withConfig({
    componentId: "sc-da0aae9d-2"
}).withConfig({
    componentId: "sc-746f83e0-2"
})(_templateObject4(), Spinner_float);
var Spinner = function Spinner(param) {
    var _size = param.size, size = _size === void 0 ? 128 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RotatingPancakeIcon, {
                width: "".concat(size * 0.5, "px")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingPanIcon, {
                width: "".concat(size, "px")
            })
        ]
    });
};
/* harmony default export */ var Spinner_Spinner = (Spinner);


/***/ }),

/***/ 6372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M11 5V16.17L6.11997 11.29C5.72997 10.9 5.08997 10.9 4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7L11.29 19.29C11.68 19.68 12.31 19.68 12.7 19.29L19.29 12.7C19.68 12.31 19.68 11.68 19.29 11.29C18.9 10.9 18.27 10.9 17.88 11.29L13 16.17V5C13 4.45 12.55 4 12 4C11.45 4 11 4.45 11 5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 16274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 19V7.83001L17.88 12.71C18.27 13.1 18.91 13.1 19.3 12.71C19.69 12.32 19.69 11.69 19.3 11.3L12.71 4.71001C12.32 4.32001 11.69 4.32001 11.3 4.71001L4.69997 11.29C4.30997 11.68 4.30997 12.31 4.69997 12.7C5.08997 13.09 5.71997 13.09 6.10997 12.7L11 7.83001V19C11 19.55 11.45 20 12 20C12.55 20 13 19.55 13 19Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 49234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ AddToWalletTextOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95963);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99673);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11200);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14905);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83313);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19551);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65335);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96293);
/* harmony import */ var components_Logo_Logo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79350);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5286);








var AddToWalletTextOptions;
(function(AddToWalletTextOptions) {
    AddToWalletTextOptions[AddToWalletTextOptions["NO_TEXT"] = 0] = "NO_TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT"] = 1] = "TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT_WITH_ASSET"] = 2] = "TEXT_WITH_ASSET";
})(AddToWalletTextOptions || (AddToWalletTextOptions = {}));
var Icons = {
    // TODO: Brave
    Binance: _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
    "Coinbase Wallet": _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    Opera: _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    TokenPocket: _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    "Trust Wallet": _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    MetaMask: _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
};
var getWalletText = function(textOptions, tokenSymbol, t) {
    var ref;
    // @ts-ignore
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isSafePal) {
        return null;
    }
    return textOptions !== AddToWalletTextOptions.NO_TEXT && (textOptions === AddToWalletTextOptions.TEXT ? t("Add to Wallet") : t("Add %asset% to Wallet", {
        asset: tokenSymbol
    }));
};
var getWalletIcon = function(marginTextBetweenLogo, name) {
    var ref, ref1, ref2, ref3, ref4;
    // @ts-ignore
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isSafePal) {
        return null;
    }
    var iconProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        width: "16px"
    }, marginTextBetweenLogo && {
        ml: marginTextBetweenLogo
    });
    if (name && Icons[name]) {
        var Icon = Icons[name];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isTrust) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isCoinbaseWallet) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isTokenPocket) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref4 = window.ethereum) === null || ref4 === void 0 ? void 0 : ref4.isMetaMask) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps));
};
var AddToWalletButton = function(_param) {
    var tokenAddress = _param.tokenAddress, tokenSymbol = _param.tokenSymbol, tokenDecimals = _param.tokenDecimals, tokenLogo = _param.tokenLogo, _textOptions = _param.textOptions, textOptions = _textOptions === void 0 ? AddToWalletTextOptions.NO_TEXT : _textOptions, _marginTextBetweenLogo = _param.marginTextBetweenLogo, marginTextBetweenLogo = _marginTextBetweenLogo === void 0 ? "0px" : _marginTextBetweenLogo, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "tokenAddress",
        "tokenSymbol",
        "tokenDecimals",
        "tokenLogo",
        "textOptions",
        "marginTextBetweenLogo"
    ]);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_11__/* .useAccount */ .mA)(), connector = ref.connector, isConnected = ref.isConnected;
    if (!(connector && connector.watchAsset && isConnected)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        onClick: function() {
            var ref;
            var image = tokenLogo ? components_Logo_Logo__WEBPACK_IMPORTED_MODULE_2__/* .BAD_SRCS */ .X[tokenLogo] ? undefined : tokenLogo : undefined;
            (ref = connector.watchAsset) === null || ref === void 0 ? void 0 : ref.call(connector, {
                address: tokenAddress,
                symbol: tokenSymbol,
                image: image,
                // @ts-ignore
                decimals: tokenDecimals
            });
        },
        children: [
            getWalletText(textOptions, tokenSymbol, t),
            getWalletIcon(marginTextBetweenLogo, connector === null || connector === void 0 ? void 0 : connector.name)
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AddToWalletButton);


/***/ }),

/***/ 77214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Input; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95963);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93293);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-8de12016-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "right";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .escapeRegExp */ .hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledInput, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 79,
        spellCheck: "false"
    }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Input)));


/***/ }),

/***/ 71372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CurrencyInputPanel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(65528);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(6260);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87379);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93293);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95963);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28073);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64011);
/* harmony import */ var hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90834);
/* harmony import */ var utils_formatBalance__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65044);
/* harmony import */ var _state_wallet_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71900);
/* harmony import */ var _SearchModal_CurrencySearchModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68326);
/* harmony import */ var _Logo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74314);
/* harmony import */ var _NumericalInput__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77214);
/* harmony import */ var _CopyButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57370);
/* harmony import */ var _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49234);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 8px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: ",
        " 8px 0px 0px;\n      height: auto;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 0.5rem;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-radius: 0px 16px 16px 16px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 16px;\n  background-color: ",
        ";\n  box-shadow: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  inset: 0;\n  opacity: 0.6;\n  background-color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}















var InputRow = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-0"
})(_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "0.75rem 0.5rem 0.75rem 1rem" : "0.75rem 0.75rem 0.75rem 1rem";
});
var CurrencySelectButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-ed726ef6-1"
})(_templateObject2(), function(param) {
    var zapStyle = param.zapStyle, theme = param.theme;
    return zapStyle && (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .css */ .iv)(_templateObject1(), theme.colors.background, theme.colors.cardBorder, zapStyle === "zap" ? "0px" : "8px");
});
var LabelRow = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-4"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme, error = param.error;
    return theme.shadows[error ? "warning" : "inset"];
}, function(param) {
    var zapStyle = param.zapStyle;
    return !!zapStyle && (0,styled_components__WEBPACK_IMPORTED_MODULE_14__/* .css */ .iv)(_templateObject5());
});
var Overlay = styled_components__WEBPACK_IMPORTED_MODULE_14__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed726ef6-5"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, onMax = param.onMax, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, zapStyle = param.zapStyle, beforeButton = param.beforeButton, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, disabled = param.disabled, error = param.error, showBUSD = param.showBUSD;
    var account = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().account;
    var selectedCurrencyBalance = (0,_state_wallet_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useCurrencyBalance */ ._h)(account !== null && account !== void 0 ? account : undefined, currency !== null && currency !== void 0 ? currency : undefined);
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var token = pair ? pair.liquidityToken : (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency : null;
    var tokenAddress = token ? (0,utils__WEBPACK_IMPORTED_MODULE_2__/* .isAddress */ .UJ)(token.address) : null;
    var amountInDollar = (0,hooks_useBUSDPrice__WEBPACK_IMPORTED_MODULE_6__/* .useBUSDCurrencyAmount */ .vB)(showBUSD ? currency : undefined, Number.isFinite(+value) ? +value : undefined);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SearchModal_CurrencySearchModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        children: [
                            beforeButton,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CurrencySelectButton, {
                                zapStyle: zapStyle,
                                className: "open-currency-select-button",
                                selected: !!currency,
                                onClick: function() {
                                    if (!disableCurrencySelect) {
                                        onPresentCurrencyModal();
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    children: [
                                        pair ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_10__/* .DoubleCurrencyLogo */ .ge, {
                                            currency0: pair.token0,
                                            currency1: pair.token1,
                                            size: 16,
                                            margin: true
                                        }) : currency ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Logo__WEBPACK_IMPORTED_MODULE_10__/* .CurrencyLogo */ .Xw, {
                                            currency: currency,
                                            size: "24px",
                                            style: {
                                                marginRight: "8px"
                                            }
                                        }) : null,
                                        pair ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            id: "pair",
                                            bold: true,
                                            children: [
                                                pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                                ":",
                                                pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            id: "pair",
                                            bold: true,
                                            children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                        }),
                                        !disableCurrencySelect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {})
                                    ]
                                })
                            }),
                            token && tokenAddress ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                style: {
                                    gap: "4px"
                                },
                                ml: "4px",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CopyButton__WEBPACK_IMPORTED_MODULE_12__/* .CopyButton */ .q, {
                                        width: "16px",
                                        buttonColor: "textSubtle",
                                        text: tokenAddress,
                                        tooltipMessage: t("Token address copied"),
                                        tooltipTop: -20,
                                        tooltipRight: 40,
                                        tooltipFontSize: 12
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        variant: "text",
                                        p: "0",
                                        height: "auto",
                                        width: "fit-content",
                                        tokenAddress: tokenAddress,
                                        tokenSymbol: token.symbol,
                                        tokenDecimals: token.decimals,
                                        tokenLogo: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(token, _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_4__/* .WrappedTokenInfo */ .DT) ? token.logoURI : undefined
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    account && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        onClick: !disabled && onMax,
                        color: "textSubtle",
                        fontSize: "14px",
                        style: {
                            display: "inline",
                            cursor: "pointer"
                        },
                        children: !hideBalance && !!currency ? t("Balance: %balance%", {
                            balance: (ref1 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref1 !== void 0 ? ref1 : t("Loading")
                        }) : " -"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputPanel, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
                        as: "label",
                        zapStyle: zapStyle,
                        error: error,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LabelRow, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_NumericalInput__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .I, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InputRow, {
                                selected: disableCurrencySelect,
                                children: [
                                    !!currency && showBUSD && Number.isFinite(amountInDollar) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        mr: "12px",
                                        children: [
                                            "~",
                                            (0,utils_formatBalance__WEBPACK_IMPORTED_MODULE_7__/* .formatNumber */ .uf)(amountInDollar),
                                            " USD"
                                        ]
                                    }),
                                    account && currency && !disabled && showMaxButton && label !== "To" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        onClick: onMax,
                                        scale: "xs",
                                        variant: "secondary",
                                        style: {
                                            textTransform: "uppercase"
                                        },
                                        children: t("Max")
                                    })
                                ]
                            })
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Overlay, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 41228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ht": function() { return /* binding */ TransactionErrorContent; },
/* harmony export */   "pM": function() { return /* binding */ ConfirmationModalContent; },
/* harmony export */   "rD": function() { return /* binding */ TransactionSubmittedContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63603);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16274);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80421);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96293);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(44700);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90452);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95963);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64011);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53854);
/* harmony import */ var _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28073);
/* harmony import */ var _Layout_Column__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41914);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93293);
/* harmony import */ var _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49234);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ff0237e2-0"
})(_templateObject());
var Section = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_7__/* .AutoColumn */ .Tz).withConfig({
    componentId: "sc-ff0237e2-1"
})(_templateObject1());
var ConfirmedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(_Layout_Column__WEBPACK_IMPORTED_MODULE_7__/* .ColumnCenter */ .lg).withConfig({
    componentId: "sc-ff0237e2-2"
})(_templateObject2());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_7__/* .AutoColumn */ .Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Layout_Column__WEBPACK_IMPORTED_MODULE_7__/* .AutoColumn */ .Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var token = (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_5__/* .wrappedCurrency */ .pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "primary"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_7__/* .AutoColumn */ .Tz, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            external: true,
                            small: true,
                            href: (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getBlockExploreLink */ .C)(hash, "transaction", chainId),
                            children: t("View on %site%", {
                                site: (0,_utils__WEBPACK_IMPORTED_MODULE_8__/* .getBlockExploreName */ .X0)(chainId)
                            })
                        }),
                        currencyToAdd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            variant: "tertiary",
                            mt: "12px",
                            width: "fit-content",
                            marginTextBetweenLogo: "6px",
                            textOptions: _AddToWallet_AddToWalletButton__WEBPACK_IMPORTED_MODULE_9__/* .AddToWalletTextOptions.TEXT_WITH_ASSET */ .L.TEXT_WITH_ASSET,
                            tokenAddress: token.address,
                            tokenSymbol: currencyToAdd.symbol,
                            tokenDecimals: token.decimals,
                            tokenLogo: (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(token, _pancakeswap_tokens__WEBPACK_IMPORTED_MODULE_6__/* .WrappedTokenInfo */ .DT) ? token.logoURI : undefined
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            onClick: onDismiss,
                            mt: "20px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Layout_Column__WEBPACK_IMPORTED_MODULE_7__/* .AutoColumn */ .Tz, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        color: "failure",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        color: "failure",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            onDismiss ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            }) : null
        ]
    });
}
var TransactionConfirmationModal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, attemptingTxn = _param.attemptingTxn, hash = _param.hash, pendingText = _param.pendingText, content = _param.content, currencyToAdd = _param.currencyToAdd, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(_param, [
        "title",
        "onDismiss",
        "customOnDismiss",
        "attemptingTxn",
        "hash",
        "pendingText",
        "content",
        "currencyToAdd"
    ]);
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().chainId;
    var handleDismiss = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
        title: title,
        headerBackground: "gradients.cardHeader"
    }, props), {
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (TransactionConfirmationModal);


/***/ }),

/***/ 19508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39242);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55855);
/* harmony import */ var _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64011);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32153);
/* harmony import */ var hooks_useProviderOrSigner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77333);






var useGelatoLimitOrdersLib = function() {
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var providerOrSigner = (0,hooks_useProviderOrSigner__WEBPACK_IMPORTED_MODULE_5__/* .useProviderOrSigner */ .J)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!chainId || !providerOrSigner) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        if (chainId !== _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_1__/* .ChainId.BSC */ .a_.BSC) return undefined;
        try {
            return new _gelatonetwork_limit_orders_lib__WEBPACK_IMPORTED_MODULE_2__.GelatoLimitOrders(chainId, providerOrSigner, config_constants_exchange__WEBPACK_IMPORTED_MODULE_4__/* .GELATO_HANDLER */ .uX, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        providerOrSigner
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGelatoLimitOrdersLib);


/***/ }),

/***/ 50165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "tz": function() { return /* binding */ useApproveCallbackFromInputCurrencyAmount; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(67539);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(95963);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts + 1 modules
var exchange = __webpack_require__(32153);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(39242);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(91001);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(70193);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(55892);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./src/hooks/useCallWithGasPrice.ts
var useCallWithGasPrice = __webpack_require__(71228);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts
var useGelatoLimitOrdersLib = __webpack_require__(19508);
;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts

















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var ref;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var callWithGasPrice = (0,useCallWithGasPrice/* useCallWithGasPrice */.d)().callWithGasPrice;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* default */.Z)().toastError;
    var token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,transactions_hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        var ref;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if ((ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isNative) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var useExact, estimatedGas;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(approvalState !== ApprovalState.NOT_APPROVED)) {
                        _ctx.next = 4;
                        break;
                    }
                    toastError(t("Error"), t("Approve was called unnecessarily"));
                    console.error("approve was called unnecessarily");
                    return _ctx.abrupt("return");
                case 4:
                    if (token) {
                        _ctx.next = 8;
                        break;
                    }
                    toastError(t("Error"), t("No token"));
                    console.error("no token");
                    return _ctx.abrupt("return");
                case 8:
                    if (tokenContract) {
                        _ctx.next = 12;
                        break;
                    }
                    toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                        tokenAddress: token === null || token === void 0 ? void 0 : token.address
                    }));
                    console.error("tokenContract is null");
                    return _ctx.abrupt("return");
                case 12:
                    if (amountToApprove) {
                        _ctx.next = 16;
                        break;
                    }
                    toastError(t("Error"), t("Missing amount to approve"));
                    console.error("missing amount to approve");
                    return _ctx.abrupt("return");
                case 16:
                    if (spender) {
                        _ctx.next = 20;
                        break;
                    }
                    toastError(t("Error"), t("No spender"));
                    console.error("no spender");
                    return _ctx.abrupt("return");
                case 20:
                    useExact = false;
                    _ctx.next = 23;
                    return tokenContract.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                        // general fallback for tokens who restrict approval amounts
                        useExact = true;
                        return tokenContract.estimateGas.approve(spender, amountToApprove.quotient.toString());
                    });
                case 23:
                    estimatedGas = _ctx.sent;
                    return _ctx.abrupt("return", callWithGasPrice(tokenContract, "approve", [
                        spender,
                        useExact ? amountToApprove.quotient.toString() : bignumbers/* MaxUint256 */.Bz
                    ], {
                        gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                    }).then(function(response) {
                        addTransaction(response, {
                            summary: "Approve ".concat(amountToApprove.currency.symbol),
                            translatableSummary: {
                                text: "Approve %symbol%",
                                data: {
                                    symbol: amountToApprove.currency.symbol
                                }
                            },
                            approval: {
                                tokenAddress: token.address,
                                spender: spender
                            },
                            type: "approve"
                        });
                    }).catch(function(error) {
                        (0,sentry/* logError */.H)(error);
                        console.error("Failed to approve token", error);
                        if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                            toastError(t("Error"), error.message);
                        }
                        throw error;
                    }));
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        addTransaction,
        callWithGasPrice,
        t,
        toastError
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = (0,useGelatoLimitOrdersLib/* default */.Z)();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}


/***/ }),

/***/ 71228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCallWithGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_buildhome_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_buildhome_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68605);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92876);









function useCallWithGasPrice() {
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGasPrice */ .Fh)();
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_opt_buildhome_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(contract, methodName) {
            var methodArgs, overrides, contractMethod, hasManualGasPriceOverride, tx, ref, _args = arguments;
            return _opt_buildhome_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        methodArgs = _args.length > 2 && _args[2] !== void 0 ? _args[2] : [], overrides = _args.length > 3 && _args[3] !== void 0 ? _args[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with gas price: ".concat(gasPrice),
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(contract, methodName);
                        hasManualGasPriceOverride = overrides === null || overrides === void 0 ? void 0 : overrides.gasPrice;
                        _ctx.next = 6;
                        return contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(methodArgs).concat([
                            hasManualGasPriceOverride ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides) : (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, overrides), {
                                gasPrice: gasPrice
                            }), 
                        ]));
                    case 6:
                        tx = _ctx.sent;
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return _ctx.abrupt("return", tx);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), [
        gasPrice
    ]);
    return {
        callWithGasPrice: callWithGasPrice
    };
}


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92876);


var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var isUserRejected = function(err) {
    // provider user rejected error code
    return typeof err === "object" && "code" in err && err.code === 4001;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ })

}]);